module.exports = __webpack_public_path__ + "static/img/qianyue5.e25cb40.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/qianyue5.png
// module id = NQ15
// module chunks = 1